import request from '../../utils/request'

// 查询所有
export function fetchAll (data) {
  return request.get('/template/all')
}

// 查询
export function fetchList (data) {
  return request.post('/template/page', data, {
    trim: true
  })
}

// 查询模版属性
export function fetchPropList (id) {
  return request.get(`/template/props/${id}`)
}

// 创建
export function create (data) {
  return request.post('/template/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/template/updateById', data)
}

// 保存
export function save (data) {
  return request.post('/template/save', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/template/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/template/delete/batch', {
    params: {
      ids
    }
  })
}
